
import { Component, Vue } from 'vue-property-decorator'
import { getOilsByPage, createOil, updateOil, deleteOil } from '@/api/oli'
import Empty from '@/components/Empty/index.vue'
@Component({ components: { Empty } })
export default class OilManager extends Vue {
  private name: string = ''
  private tableData: Array<any> = []
  private counts: number = 0
  private pageSize: number = 10
  private currentPage: number = 1
  private
  dialogVisible: boolean = false
  private dialogTitle: string = ''
  private currentOil: any = {}
  private isSearch: boolean = false
  private rules = {
    name: [{ required: true, message: '油名称不能为空', trigger: 'blur' }],
    engname: [{ required: true, message: '英文名称不能为空', trigger: 'blur' }],
    zhj: [{ required: true, message: '皂化价(油)不能为空', trigger: 'blur' }],
    zhjwater: [
      { required: true, message: '皂化价(液)不能为空', trigger: 'blur' },
    ],
    ins: [{ required: true, message: 'INS值不能为空', trigger: 'blur' }],
  }
  created() {
    this.init()
  }
  private async init() {
    this.isSearch = true
    const res = await getOilsByPage({
      name: this.name,
      page: this.currentPage,
      pageSize: this.pageSize,
    })
    if (res.data.code === 1) {
      this.tableData = res.data.data.records
      this.counts = res.data.data.total
    } else {
      this.$message.error(res.data.desc)
    }
  }
  private addOil() {
    this.dialogTitle = '新增油'
    this.currentOil = {
      name: '',
      engname: '',
      zhj: null,
      zhjwater: null,
      ins: null,
      text: '',
    }
    this.dialogVisible = true
  }
  private editHandle(row: any) {
    this.dialogTitle = '修改油'
    this.currentOil = { ...row }
    this.dialogVisible = true
  }
  private async deleteHandle(id: number) {
    await this.$confirm('此操作将永久删除该油，是否继续？', '确定删除', {
      confirmButtonText: '删除',
      cancelButtonText: '取消',
      type: 'warning',
    })
    const res = await deleteOil(id)
    if (res.data.code === 1) {
      this.$message.success('删除成功！')
      this.init()
    } else {
      this.$message.error(res.data.msg)
    }
  }
  private async submitForm() {
    this.$refs.oilForm.validate(async (valid: boolean) => {
      if (valid) {
        if (this.currentOil.id) {
          const res = await updateOil(this.currentOil.id, this.currentOil)
          if (res.data.code === 1) {
            this.$message.success('修改成功！')
          }
        } else {
          const res = await createOil(this.currentOil)
          if (res.data.code === 1) {
            this.$message.success('添加成功！')
          }
        }
        this.dialogVisible = false
        this.init()
      }
    })
  }
  private handleSizeChange(val: number) {
    this.pageSize = val
    this.init()
  }
  private handleCurrentChange(val: number) {
    this.currentPage = val
    this.init()
  }
}
